import React from 'react';
import { connect } from 'react-redux';
import { TWMobileNav } from '.';
import { Information } from '../Information';
import Link from 'next/link';
import { Button } from '../../subkit-ui';
import { hideNavbar as hideNavbarAction } from '../../state/actions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var TWMobileNavProfileContainer = function TWMobileNavProfileContainer(_ref) {
  var isVisible = _ref.isVisible,
      userIsProvider = _ref.userIsProvider,
      createServiceLink = _ref.createServiceLink,
      hideNavbar = _ref.hideNavbar;
  var topItems = [];
  var bottomItems = [{
    text: 'Switch to Dashboard',
    icon: 'repeat-alt',
    href: userIsProvider ? '/dashboard' : '/'
  }, // {
  //   text: 'Support',
  //   href: '#',
  // },
  // {
  //   text: 'Blog',
  //   href: '#',
  // },
  {
    text: 'Logout',
    href: '/logout'
  }];
  var bottomSlot = null;

  if (!userIsProvider && createServiceLink) {
    bottomSlot = /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center mt-12 py-8",
      children: [/*#__PURE__*/_jsx("img", {
        style: {
          width: 144
        },
        src: "https://subkit-images.s3.amazonaws.com/images/yoga-lady.svg",
        alt: "A lady doing yoga next to a cat"
      }), /*#__PURE__*/_jsx(Information, {
        heading: "Make money doing what you love to do.",
        body: "Subkit makes it easy for anybody to start a subscription service doing something they\u2019re passionate about.",
        classes: {
          heading: 'text-center text-2xl leading-10',
          body: 'text-center text-base'
        }
      }), /*#__PURE__*/_jsx(Link, {
        href: '#',
        children: /*#__PURE__*/_jsx("a", {
          children: /*#__PURE__*/_jsx(Button, {
            text: "Get Started for Free"
          })
        })
      })]
    });
  }

  if (!isVisible) {
    return null;
  }

  return /*#__PURE__*/_jsx(TWMobileNav, {
    topItems: topItems,
    bottomItems: bottomItems,
    onClose: hideNavbar,
    leftSlot: /*#__PURE__*/_jsx("img", {
      className: "w-10",
      src: "https://subkit-images.s3.amazonaws.com/subkit-logos-images/favicon.ico"
    }),
    bottomSlot: bottomSlot
  });
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$auth$users$cur;

  return {
    userIsProvider: !!((_state$auth$users$cur = state.auth.users['current']) !== null && _state$auth$users$cur !== void 0 && _state$auth$users$cur.provider),
    isVisible: state.navbar.isVisible
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    hideNavbar: function hideNavbar() {
      return dispatch(hideNavbarAction());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TWMobileNavProfileContainer);